export default __webpack_public_path__ + "static/media/04.7e67b07d.jpg";